import React, { useCallback } from 'react'
import Typography from '@material-ui/core/Typography'
import Breadcrumbs from '@material-ui/core/Breadcrumbs'
import SvgIcon from '@material-ui/core/SvgIcon'
import { ReactComponent as IconArrowRight } from 'assets/icons/arrow-right.svg'
import useStyles from './styles'

const Breadcrumb = props => {
  const { links, current } = props
  const classes = useStyles()

  const handleClick = useCallback(e => {
    e.stopPropagation()
    e.preventDefault()
  }, [])

  return (
    <Breadcrumbs
      itemsBeforeCollapse={0}
      maxItems={1}
      aria-label="breadcrumb"
      className={classes.root}
      separator={<SvgIcon component={IconArrowRight} fontSize="small" />}
      onClick={handleClick}
      {...props}
    >
      {links
        ? links.map(link => (
            <Typography
              variant="subtitle1"
              className={classes.link}
              key={link.label}
            >
              {link.label}
            </Typography>
          ))
        : null}

      <Typography className={classes.current} variant="subtitle1">
        {current}
      </Typography>
    </Breadcrumbs>
  )
}

export default Breadcrumb
